<header class="go-header">
  <div class="go-header__left">
    <div
      class="go-header__menu-container"
      [ngStyle]="{ 'background': brandColor, 'color': fontColor }">
      <go-icon
        (click)="sideNavService.toggleNav()"
        (mouseenter)="enableMenuHover()"
        (mouseleave)="disableMenuHover()"
        [ngStyle]="{ 'background': menuBgHover }"
        class="go-header__menu"
        icon="menu">
      </go-icon>
    </div>
    <div
      class="go-header__logo-container"
      [ngClass]="{ 'go-header__logo-container--collapsed': isNavCollapsed() }"
      [ngStyle]="{ 'background': getLogoBackground() }">
      <ng-container *ngIf="logoConfig">
        <a
          *ngIf="!logoConfig.useHref; else logoNotRouterLink"
          [routerLink]="[logoConfig.logoLink]"
          class="go-header__logo">
          <img
            alt="{{ logoConfig.altText }}"
            [src]="getLogo()"/>
        </a>
        <ng-template #logoNotRouterLink>
          <a 
            [href]="logoConfig.logoLink"
            class="go-header__logo">
            <img
              alt="{{ logoConfig.altText }}"
              [src]="getLogo()"/> 
          </a>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div class="go-header__middle">
    <ng-content select="[go-header-middle]"></ng-content>
  </div>
  <div class="go-header__right">
    <ng-content select="[go-header-right]"></ng-content>
  </div>
</header>
